import React, { useCallback, memo, Fragment } from 'react';
import PropTypes from 'prop-types';

import Traductor from '../../Traductor';

const SelectInput = ({
    options,
    onChange,
    onFilter,
    label,
    values,
    name,
    row,
    touched = {},
    errors = {},
}) => {
    const t = new Traductor();
    const renderOptions = useCallback(() => {
        return options.map((option, i) => (
            <option key={`${option.label}${i}`} value={option.value}>
                {option.label}
            </option>
        ));
    }, [options]);
    const renderError = useCallback(
        () =>
            touched[name] &&
            errors[name] && <p className="c-error-message">*{errors[name]}</p>,
        [errors, name, touched]
    );
    const ViewTitle = () => {
        if (label === '') {
            return label;
        } else {
            return (
                <div className="c-accordion__header js-accordion__title c-vehicle-filters__item-title">
                    <span className="c-accordion__title"></span>
                    <h3 className="c-accordion__title">
                        <button
                            className="c-accordion__title-label js-accordion__title-label"
                            aria-expanded="true"
                            type="button"
                        >
                            <label
                                htmlFor={name}
                                className="c-accordion__title-label-text "
                            >
                                {label}
                            </label>
                        </button>
                    </h3>
                </div>
            );
        }
    };
    return (
        <Fragment>
            <ViewTitle />
            <div
                className="c-accordion__panel  js-accordion__panel c-ticket-filters__item-content"
                aria-hidden="false"
            >
                <div
                    className={
                        'c-accordion__content c-vehicle-filters__' + name
                    }
                >
                    <div className="c-input  c-input--select">
                        <select
                            className="c-input__input  "
                            name={name}
                            value={values[name]}
                            id={name}
                            onChange={e => {
                                onChange(name, e.target.value);
                                onFilter && onFilter();
                            }}
                        >
                            <option disabled hidden>
                                {t.getTraduction('SelectOptionPlaceholder')}
                            </option>
                            <option
                                key={t.getTraduction('SelectOptionPlaceholder')}
                                value=""
                            ></option>
                            {renderOptions()}
                        </select>
                    </div>
                </div>
                {renderError()}
            </div>
        </Fragment>
    );
};

SelectInput.propTypes = {
    row: PropTypes.any,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.any.isRequired,
            label: PropTypes.string.isRequired,
        })
    ),
    errors: PropTypes.object,
    touched: PropTypes.object,
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    values: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
};

export default memo(SelectInput);
